<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 ">
    <div class="row justify-content-center" style="height: 100vh">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="small-header">
          신규 계약 추가하기
        </div>
        <div class="card-body px-0 pt-0 pb-2 table-with-search">
          <a-tabs v-if="capabilities" v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="전체" v-if="visibleAllContract">
              <div class="col-sm-12 col-xs-12 list-container">
                <contract-item v-for="item in templates"
                               :imgUrl="uiHandler.getImageUrl(item.metadatas)"
                               :title="item.title"
                               :group="uiHandler.getTemplateGroup(item.metadatas)"
                               :modifiedDate="uiHandler.getTemplateModified(item)"
                               :id="item.id"
                               :isReady="item.isReady"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="TemplateGroup.장비" v-if="visibleEquipmentContract">
              <div class="col-sm-12 col-xs-12 list-container">
                <contract-item v-for="item in uiHandler.getFilterTemplate(TemplateGroup.장비)"
                               :imgUrl="uiHandler.getImageUrl(item.metadatas)"
                               :title="item.title"
                               :group="uiHandler.getTemplateGroup(item.metadatas)"
                               :modifiedDate="uiHandler.getTemplateModified(item)"
                               :id="item.id"
                               :isReady="item.isReady"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" :tab="TemplateGroup.영업" v-if="visibleSalesContract">
              <div class="col-sm-12 col-xs-12 list-container">
                <contract-item v-for="item in uiHandler.getFilterTemplate(TemplateGroup.영업)"
                               :imgUrl="uiHandler.getImageUrl(item.metadatas)"
                               :title="item.title"
                               :group="uiHandler.getTemplateGroup(item.metadatas)"
                               :modifiedDate="uiHandler.getTemplateModified(item)"
                               :id="item.id"
                               :isReady="item.isReady"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="4" :tab="TemplateGroup.고객지원" v-if="visibleInstallConfirmContract">
              <div class="col-sm-12 col-xs-12 list-container">
                <contract-item v-for="item in uiHandler.getFilterTemplate(TemplateGroup.고객지원)"
                               :imgUrl="uiHandler.getImageUrl(item.metadatas)"
                               :title="item.title"
                               :group="uiHandler.getTemplateGroup(item.metadatas)"
                               :modifiedDate="uiHandler.getTemplateModified(item)"
                               :id="item.id"
                               :isReady="item.isReady"
                />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div style="width: 100%; display: flex; justify-content: center; margin-top: 20px;">
          <button type="button" class="certi-gray-btn certi-btn-regular btn-hover"
                  style="width: 300px;"
                  @click="$router.push(contractListPath)"
          >
            <p>목록으로 돌아가기</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {ref} from 'vue';
import {TemplateGroup} from "@/views/ContractManagement/enums";

</script>
<script>
import { getProfile } from '@/utils/tokenStore';
import { masterCheckUsername } from '@/utils/supportMaster';
// v5: 계약 유형 선택 화면 (contracts-api 전용). v1 ContractTypeList.vue를 그대로 포팅했고,
// 화면 요구사항(탭 노출 조건·환경별 템플릿 필터)은 v1과 동일하게 verbatim 이식했다 —
// 새로 판단하지 않았다(잘못 바꾸면 운영에서 조용히 다른 템플릿 집합이 노출된다).
//
// ContractItem, TemplateGroup은 v1(ContractManagement) 소유 컴포넌트/enum을 그대로 재사용한다.
// v1은 이 화면 신설로 인해 전혀 수정되지 않았다.
//
// [v5 create 화면 연결 지점] ContractItemV5(이 화면 전용 아이템 컴포넌트, v1 ContractItem을 포팅)는
// 클릭 시 title→v5 create 라우트 name 매핑(routeMap.js)을 거쳐 이동한다. 매핑에 없는 title(아직
// v5 create 화면이 없는 4종)은 v1 create 라우트로 폴백한다 — routeMap.js 주석 참조.
// 물품매매V4(MulpumV6) 1건만 v5 create 화면이 존재하는 현재 라운드의 의도된 동작이다.

import {RouterEnum} from "@/enums/router.enums";
import ContractItemV5 from '@/views/ContractManagementV5/components/ContractItemV5.vue';
import {
  logging,
  convertDate,
  formatCommaNumber, jwtDecoder,
} from "@/utils/utils";
import NoResult from "@/views/components/NoResult.vue";
import Pagination from "@/views/components/Pagination.vue";
import {TemplateGroup} from "@/views/ContractManagement/enums";
import contractApi from "@/views/ContractManagementV5/api";
import contractsApiInstance from "@/contractsApi";
import {fetchContractViewCapabilities} from "@/views/ContractManagementV5/capabilities";

import {CONTRACT_LIST_PATH} from '@/utils/contractConsole';
export default {
  // v1 ContractTypeList와 라우트 name이 충돌하지 않도록 별도 이름 사용 (ContractItem의
  // $router.push({name: this.title})는 모두싸인 템플릿명 기반이라 이 컴포넌트 자체 name과는 무관).
  name: 'ContractTypeListV5',
  components: {
    Pagination,
    NoResult,
    // 템플릿의 <contract-item> 태그명은 그대로 두고, 실제 구현만 v5 전용 컴포넌트로 교체한다.
    ContractItem: ContractItemV5,
  },
  async mounted() {
    this.uiHandler.init();
    // 기본 탭이 CS 명단 포함 여부에 달려 있어 응답 뒤에 정한다. 응답 전에는 탭을 그리지 않는다(template v-if).
    this.capabilities = await fetchContractViewCapabilities();
    if (this.isDentiumMasterUser) {
      this.activeKey = "1" // 전체
    } else if (this.isCsTeam) {
      this.activeKey = "4" // 고객지원
    } else if (this.isPlasmappMasterUser) {
      this.activeKey = "3" // 영업
    } else {
      // 장비 탭 비노출로 전환되어, 기본 진입 탭을 영업으로 내린다.
      // (기존 기본값 "2"(장비)를 그대로 두면 숨겨진 탭이 선택돼 빈 화면이 보인다) — v1과 동일
      this.activeKey = "3" // 영업
    }
  },
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.contract.totalDocs === 0
    },
    isCsTeam() {
      const companyInfo = JSON.parse(getProfile('CompanyInfo'));
      const accountInfo = companyInfo.accountInfo
      // 지점 소속 CS 엔지니어 명단은 권한관리 화면 데이터다 — 포함 여부만 서버(capabilities)에서 받는다.
      // 소속 판단은 기존과 같은 출처(로그인 시 저장된 계정 정보)를 그대로 쓴다(SPEC-CONTRACT-VIEW-GRANT-001).
      return (accountInfo.deptName && accountInfo.deptName.includes("고객지원"))
        || this.capabilities?.csEngineer === true
    },
    isDentiumMasterUser() {
      const companyInfo = JSON.parse(getProfile('CompanyInfo'));
      const accountInfo = companyInfo.accountInfo
      return masterCheckUsername(accountInfo.username, this.$store.state.privileges) === "dentium" // 지원 탭 = 그 회사 최상위 관리자(utils/supportMaster)
    },
    isPlasmappMasterUser() {
      const companyInfo = JSON.parse(getProfile('CompanyInfo'));
      const accountInfo = companyInfo.accountInfo
      const username = masterCheckUsername(accountInfo.username, this.$store.state.privileges) // 지원 탭 = 그 회사 최상위 관리자(utils/supportMaster)
      return username === "bkpark1@plasmapp.com" || username === "plasmapp";
    },
    visibleAllContract() {
      return this.isDentiumMasterUser
    },
    visibleSalesContract() {
      return !this.isCsTeam
    },
    visibleEquipmentContract() {
      // 장비 계약서는 물품매매 계약서로 통합 진행 중이라 탭 전체를 비노출한다 — v1과 동일하게 유지.
      // (모두싸인 템플릿 7종의 prod-id 메타데이터도 함께 제거되어 운영에서 조회되지 않음)
      // 통합 완료 후 되살릴 때는 v1 원본 조건을 함께 참고할 것.
      return false
    },
    visibleInstallConfirmContract() {
      return this.isCsTeam || this.isDentiumMasterUser;
    },
    computedNoResultMessage() {
      if (this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_product');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
  },
  data() {
    return {
      formatCommaNumber,
      logging,
      convertDate,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractListPath: CONTRACT_LIST_PATH,
      calledApiTimes: 0,
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      templates: [],
      activeKey: "1",
      capabilities: null,
    }
  },
  methods: {
    ui() {
      const getTargetValue = (array, targetValue) => {
        if (!array) return;

        array.forEach(item => {
          if (item.name === targetValue || item.key === targetValue) {
            return item;
          }
        })
      }
      return {
        init: async () => {
          await this.apiHandler.getContractTemplates(
              {
                page: this.paginationData.currentPage,
                limit: this.paginationData.rowsPerPage * 5
              },
              (response) => {
                if(process.env.NODE_ENV === 'stage') {
                  // 스테이징 전용 템플릿도 노출되도록 stg-id 또는 prod-id 메타데이터가 있으면 표시 — v1과 동일 분기
                  this.templates = response.data.docs.filter(item => {
                      return item.metadatas && item.metadatas.some(metadata => metadata.key === 'stg-id' || metadata.key === 'prod-id');
                  });
                } else {
                  this.templates = response.data.docs;
                }
                this.templates.forEach(template => {
                  if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                    // 로컬, 개발 환경에서는 계약서 템플릿을 항상 보이게 처리 — v1과 동일
                    template.isReady = true
                  } else {
                    // 스테이징, 운영 환경에서는 계약서 템플릿을 메타데이터의 "isReady 값이 Y: 정상배포, N: 준비중" 으로 처리
                    template.isReady = template.metadatas?.find(m => m.key === 'isReady')?.value === 'Y'
                  }
                });
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error)
              }
          )
        },
        getImageUrl(metadatas) {
          const imgBaseUrl = metadatas.find(m => m.key === 'imgBaseUrl')?.value || '';
          const imgBasePath = metadatas.find(m => m.key === 'imgBasePath')?.value || '';
          const imgRemainingPart = metadatas.find(m => m.key === 'imgRemainingPart')?.value || '';
          return imgBaseUrl + imgBasePath + imgRemainingPart;
        },
        getTemplateGroup(metadatas) {
            return metadatas.find(m => m.key === 'contractGroup')?.value
        },
        getTemplateModified(item) {
          return item.updateAt ? convertDate(item.updatedAt) : convertDate(item.createdAt)
        },
        getFilterTemplate: (group) => this.templates.filter(t => {
          const contractGroup = t.metadatas.find(m => m.key === 'contractGroup');
          return contractGroup && contractGroup.value === group;
        }),
        getTargetValue,
      }
    },
    api() {
      // v5: contracts-api 인스턴스 바인딩 (v1의 this.$apiInstance 대신 contractsApiInstance)
      return contractApi(contractsApiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-type.scss';
</style>
